"use client";
import { RouteError } from "@/components/RouteError";

export default function StoreError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <RouteError
      error={error}
      reset={reset}
      label="STORE ERROR"
      backHref="/browse"
      backLabel="Back to Browse"
    />
  );
}
